import React from 'react'
import { reduxForm, Field } from 'redux-form'

import WrappedInput from '../Shared/Forms/WrappedInput'
import Button from '../Shared/Button'
import Card from '../Shared/Card'
import FormError from '../Shared/Forms/FormError'

const FORM_NAME = 'loginForm'

const Form = function LoginForm({ handleSubmit, submitting, error }) {
  return (
    <form onSubmit={handleSubmit}>
      <Card actions={<Button loading={submitting}>Login</Button>}>
        <h1>Login</h1>
        <Field
          name="email"
          placeholder="Email"
          type="email"
          component={WrappedInput}
        />
        <Field
          name="password"
          placeholder="Password"
          type="password"
          component={WrappedInput}
        />
        {error && <FormError>{error}</FormError>}
      </Card>
    </form>
  )
}

export default reduxForm({
  form: FORM_NAME,
})(Form)
